import { render, staticRenderFns } from "./TableFormal.vue?vue&type=template&id=78f2277e&"
import script from "./TableFormal.vue?vue&type=script&lang=js&"
export * from "./TableFormal.vue?vue&type=script&lang=js&"
import style0 from "./TableFormal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports